// extracted by mini-css-extract-plugin
module.exports = {"titleLink":"public_titleLink__2Mk0m","btn":"public_btn__15MCu"};